export const SPANISH_TEXT_REGEX = /^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]+$/;
export const SPANISH_TEXT_INPUT_REGEX = /^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]*$/;

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
export const EMAIL_VALIDATION_MESSAGE = 'Introduce un email válido (ej. usuario@dominio.com).';

export const normalizeEmail = (value: string) => value.trim().toLowerCase();

export const PHONE_REGEX = /^[0-9+()\s-]{6,}$/;
export const PHONE_VALIDATION_MESSAGE = 'Introduce un teléfono válido.';

export const isValidEmail = (value: string) => EMAIL_REGEX.test(normalizeEmail(value));

export const ensureValidEmail = (value: string): string => {
  const normalized = normalizeEmail(value);
  if (!EMAIL_REGEX.test(normalized)) {
    throw new Error(EMAIL_VALIDATION_MESSAGE);
  }
  return normalized;
};

export const isValidPhone = (value: string): boolean => PHONE_REGEX.test(value.trim());

export const ensureValidPhone = (value: string): string => {
  const normalized = value.trim();
  if (!PHONE_REGEX.test(normalized)) {
    throw new Error(PHONE_VALIDATION_MESSAGE);
  }
  return normalized;
};

export const isValidSpanishText = (value: string) => {
  const trimmed = value.trim();
  return trimmed.length > 0 && SPANISH_TEXT_REGEX.test(trimmed);
};

export const isValidSpanishTextOrEmpty = (value: string) => {
  if (!value) return true;
  return SPANISH_TEXT_INPUT_REGEX.test(value);
};

export const assertValidSpanishText = (value: string | undefined | null, fieldLabel: string): void => {
  if (value === undefined || value === null) return;
  const trimmed = value.trim();
  if (!trimmed) return;
  if (!SPANISH_TEXT_REGEX.test(trimmed)) {
    throw new Error(
      `${fieldLabel} solo puede contener letras del alfabeto español, espacios y caracteres acentuados.`
    );
  }
};
